export default __webpack_public_path__ + "static/media/RGA Primary Badge_Black Text.666518b3.png";